var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRenewals = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M11.196 3.12a5.833 5.833 0 0 0-9 4.298.5.5 0 1 0 .995.098 4.835 4.835 0 0 1 8.864-2.15h-1.389a.5.5 0 0 0 0 1h2.348a.82.82 0 0 0 .82-.82V3.2a.5.5 0 0 0-1 0v1.532a5.836 5.836 0 0 0-1.637-1.613Zm2.187 4.916a.5.5 0 0 1 .448.547 5.834 5.834 0 0 1-10.638 2.685V12.8a.5.5 0 0 1-1 0v-2.347a.82.82 0 0 1 .82-.82H5.36a.5.5 0 0 1 0 1H3.972a4.834 4.834 0 0 0 8.863-2.15.5.5 0 0 1 .548-.447Z",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgRenewals);
export default ForwardRef;